import produce from 'immer';
import {
    SET_DROPDOWN_CLOSE,
    SET_DROPDOWN_OPEN,
} from '../../actions/actionTypes';

const initState = {
    dropdownOptions: {},
    dropdownOpen: false,
    dropdownOpenId: '',
    dropdownSearch: {},
};

const dropdown = produce((draft, action) => {
    switch (action.type) {
        case SET_DROPDOWN_OPEN:
            return {
                ...draft,
                dropdownOpen: true,
                dropdownOpenId: action.dropdownOpenId,
            };
        case SET_DROPDOWN_CLOSE:
            return {
                ...draft,
                dropdownOpen: false,
                dropdownOpenId: '',
            };
    }
}, initState);

export default dropdown;
